import { Button, Modal, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface InfoModalProps {
    text?: string;
    translatedText?: string;
    buttonText?: string;
    /** Преведено заглавие; без него е общото „Сигурни ли сте?“. */
    title?: string;
    show: boolean;
    onHide: (isDelete: boolean) => void;
    isDisabled?: boolean;
    isLoading?: boolean;
}

export const InfoModal: React.FC<InfoModalProps> = ({
    text,
    translatedText,
    buttonText,
    title,
    show,
    onHide,
    children,
    isDisabled = false,
    isLoading = false,
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    return (
        <Modal
            show={show}
            onHide={() => !isLoading && onHide(false)}
            size='lg'
            centered
            backdrop={isLoading ? 'static' : true}
            keyboard={!isLoading}
        >
            <Modal.Header closeButton={!isLoading}>
                <Modal.Title id='contained-modal-title-vcenter' className='w-100 flex-center'>
                    {title ?? t('deleteModalHeader')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='d-flex  flex-column align-items-center'>
                {children}
                <p className='pt-3 mb-0'>{translatedText ?? (text ? t(text, { defaultValue: text }) : t('deleteText'))}</p>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-center'>
                <Button onClick={() => onHide(false)} variant='secondary' size='sm' className='info-modal-action' disabled={isLoading}>
                    <span className='info-modal-action-label'>{t('close')}</span>
                </Button>
                <Button
                    onClick={() => {
                        onHide(true);
                    }}
                    variant='danger'
                    size='sm'
                    className='info-modal-action'
                    disabled={isDisabled || isLoading}
                >
                    {isLoading ? <Spinner animation='border' size='sm' /> : <span className='info-modal-action-label'>{t(buttonText ?? 'delete')}</span>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
